/**
 * src/lib/constants/statusColors.js — Canonical task-status colors & cycle order.
 *
 * Single source of truth for task status visual styling across all views.
 * Keyed by canonical snake_case slugs (see SHAPE_CONTRACT.md).
 * Uses CSS custom-property tokens — never raw hex.
 */

/** Flat color map: status slug -> CSS var token (for dots, borders, text) */
export const TASK_STATUS_COLORS = {
  todo:        'var(--stodo)',
  in_progress: 'var(--spro)',
  done:        'var(--sdn)',
  blocked:     'var(--sblk)',
  review:      'var(--spro)',
  cancelled:   'var(--stodo)',
};

/** bg + color pairs for status badges/pills */
export const TASK_STATUS_STYLES = {
  todo:        { bg: 'var(--stodob)', color: 'var(--stodo)' },
  in_progress: { bg: 'var(--sprob)',  color: 'var(--spro)' },
  blocked:     { bg: 'var(--sblkb)',  color: 'var(--sblk)' },
  done:        { bg: 'var(--sdnb)',   color: 'var(--sdn)' },
  review:      { bg: 'var(--sprob)',  color: 'var(--spro)' },
  cancelled:   { bg: 'var(--stodob)', color: 'var(--stodo)' },
};

/** Canonical click-cycle order for status toggling */
export const STATUS_CYCLE = ['todo', 'in_progress', 'blocked', 'done'];

/**
 * Legacy English-label keyed color map.
 * Used by components that receive stage data with display-label keys
 * (e.g., CapacityPanel stage breakdown bars).
 */
export const TASK_STATUS_COLORS_BY_LABEL = {
  'To Do':        'var(--stodo)',
  'In Progress':  'var(--spro)',
  'Blocked':      'var(--sblk)',
  'Done':         'var(--sdn)',
  'Review':       'var(--spro)',
  'Cancelled':    'var(--stodo)',
};
